import {Activity, ActivityType} from "../../../../../model/activity.model";

export function getActivityStartTime(activity: { start: string; duration: number }): Date {
  const activityStartTime = new Date(activity.start).getTime() - activity.duration * 1000;
  return new Date(activityStartTime);
}

export const getActivityType = (activityTypes: ActivityType[], activity: Activity) => activityTypes.find(type => type.id === activity.typeId);
